import { useNavigate } from "react-router-dom";

const cityGuides = [
  { city: "İstanbul", articleId: "istanbul-gezilecek-yerler", count: 50, region: "Marmara", img: "https://readdy.ai/api/search-image?query=Istanbul%20Hagia%20Sophia%20Bosphorus%20skyline%20Turkey%20iconic%20landmark&width=400&height=280&seq=cg-ist&orientation=landscape" },
  { city: "Antalya", articleId: "antalya-gezilecek-yerler", count: 40, region: "Akdeniz", img: "https://readdy.ai/api/search-image?query=Antalya%20old%20town%20harbor%20Mediterranean%20coast%20Turkey&width=400&height=280&seq=cg-ant&orientation=landscape" },
  { city: "İzmir", articleId: "izmir-gezilecek-yerler", count: 30, region: "Ege", img: "https://readdy.ai/api/search-image?query=Izmir%20Kordon%20seafront%20clock%20tower%20Aegean%20Turkey&width=400&height=280&seq=cg-izm&orientation=landscape" },
  { city: "Ankara", articleId: "ankara-gezilecek-yerler", count: 15, region: "İç Anadolu", img: "https://readdy.ai/api/search-image?query=Ankara%20Ataturk%20Mausoleum%20Anitkabir%20capital%20city%20Turkey%20modern%20architecture&width=400&height=280&seq=cg-ank&orientation=landscape" },
  { city: "Trabzon", articleId: "trabzon-gezilecek-yerler", count: 12, region: "Karadeniz", img: "https://readdy.ai/api/search-image?query=Trabzon%20Sumela%20Monastery%20Black%20Sea%20Turkey%20cliff%20monastery%20green%20forest&width=400&height=280&seq=cg-trb&orientation=landscape" },
  { city: "Konya", articleId: "konya-gezilecek-yerler", count: 11, region: "İç Anadolu", img: "https://readdy.ai/api/search-image?query=Konya%20Mevlana%20Museum%20green%20dome%20Turkey%20Seljuk%20spiritual%20city%20whirling%20dervish&width=400&height=280&seq=cg-kon&orientation=landscape" },
  { city: "Mardin", articleId: "mardin-gezilecek-yerler", count: 12, region: "Güneydoğu", img: "https://readdy.ai/api/search-image?query=Mardin%20stone%20houses%20ancient%20city%20Turkey%20Mesopotamia%20valley%20sunset%20golden&width=400&height=280&seq=cg-mrd&orientation=landscape" },
  { city: "Kapadokya", articleId: "kapadokya-gezilecek-yerler", count: 12, region: "İç Anadolu", img: "https://readdy.ai/api/search-image?query=Cappadocia%20hot%20air%20balloons%20fairy%20chimneys%20Turkey%20sunrise%20golden%20hour&width=400&height=280&seq=cg-kap2&orientation=landscape" },
  { city: "Bursa", articleId: "bursa-gezilecek-yerler", count: 25, region: "Marmara", img: "https://readdy.ai/api/search-image?query=Bursa%20Green%20Mosque%20Uludag%20mountain%20Ottoman%20Turkey&width=400&height=280&seq=cg-bur&orientation=landscape" },
  { city: "Gaziantep", articleId: "gaziantep-gezilecek-yerler", count: 14, region: "Güneydoğu", img: "https://readdy.ai/api/search-image?query=Gaziantep%20Zeugma%20mosaic%20museum%20castle%20Turkey%20historical%20city%20baklava&width=400&height=280&seq=cg-gaz2&orientation=landscape" },
  { city: "Sakarya", articleId: "sakarya-gezilecek-yerler", count: 20, region: "Marmara", img: "https://readdy.ai/api/search-image?query=Sapanca%20lake%20forest%20nature%20Turkey%20green%20landscape%20peaceful&width=400&height=280&seq=cg-sak&orientation=landscape" },
  { city: "Pamukkale", articleId: "pamukkale-efes-rehberi", count: 12, region: "Ege", img: "https://readdy.ai/api/search-image?query=Pamukkale%20white%20travertines%20thermal%20pools%20Turkey%20UNESCO&width=400&height=280&seq=cg-pam&orientation=landscape" },
];

const allCities = [
  "Adana", "Adıyaman", "Afyonkarahisar", "Ağrı", "Aksaray", "Amasya", "Ardahan",
  "Artvin", "Aydın", "Balıkesir", "Bartın", "Batman", "Bayburt", "Bilecik", "Bingöl",
  "Bitlis", "Bolu", "Burdur", "Çanakkale", "Çankırı", "Çorum", "Denizli", "Diyarbakır",
  "Düzce", "Edirne", "Elazığ", "Erzincan", "Erzurum", "Eskişehir", "Giresun", "Gümüşhane",
  "Hakkari", "Hatay", "Iğdır", "Isparta", "Kahramanmaraş", "Karabük", "Karaman", "Kars",
  "Kastamonu", "Kayseri", "Kırıkkale", "Kırklareli", "Kırşehir", "Kilis", "Kocaeli",
  "Kütahya", "Malatya", "Manisa", "Mersin", "Muğla", "Muş", "Nevşehir",
  "Niğde", "Ordu", "Osmaniye", "Rize", "Samsun", "Siirt", "Sinop", "Sivas",
  "Şanlıurfa", "Şırnak", "Tekirdağ", "Tokat", "Tunceli", "Uşak", "Van", "Yalova", "Yozgat", "Zonguldak",
];

// Cities that have dedicated articles
const featuredCityLinks = [
  { name: "İstanbul", id: "istanbul-gezilecek-yerler" },
  { name: "Antalya", id: "antalya-gezilecek-yerler" },
  { name: "İzmir", id: "izmir-gezilecek-yerler" },
  { name: "Ankara", id: "ankara-gezilecek-yerler" },
  { name: "Trabzon", id: "trabzon-gezilecek-yerler" },
  { name: "Konya", id: "konya-gezilecek-yerler" },
  { name: "Mardin", id: "mardin-gezilecek-yerler" },
  { name: "Bursa", id: "bursa-gezilecek-yerler" },
  { name: "Sakarya", id: "sakarya-gezilecek-yerler" },
  { name: "Gaziantep", id: "gaziantep-gezilecek-yerler" },
  { name: "Kapadokya", id: "kapadokya-gezilecek-yerler" },
  { name: "Pamukkale", id: "pamukkale-efes-rehberi" },
  { name: "Şanlıurfa", id: "nemrut-gobeklitepe-rehberi" },
  { name: "Bozcaada", id: "ege-adaları-rehberi" },
];

const CityGuideLinks = () => {
  const navigate = useNavigate();

  return (
    <section className="py-16 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-10">
          <span className="text-amber-600 text-xs font-bold uppercase tracking-widest">Şehir Rehberleri</span>
          <h2
            className="text-3xl md:text-4xl font-bold text-stone-900 mt-2 mb-3"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Türkiye'de Gezilecek Yerler
          </h2>
          <p className="text-stone-500 text-sm max-w-xl mx-auto">
            İstanbul'dan Mardin'e, Trabzon'dan Antalya'ya — Türkiye'nin her ilinde gezilecek en güzel yerleri keşfedin.
          </p>
        </div>

        {/* Featured City Cards */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mb-10">
          {cityGuides.map((guide) => (
            <button
              key={guide.city}
              onClick={() => navigate(`/article/${guide.articleId}`)}
              className="group relative overflow-hidden rounded-xl cursor-pointer text-left"
            >
              <div className="w-full h-36 md:h-44 overflow-hidden">
                <img
                  src={guide.img}
                  alt={`${guide.city} gezilecek yerler`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-3">
                <span className="text-xs text-amber-300 font-medium">{guide.region}</span>
                <h3 className="text-white font-bold text-sm md:text-base leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {guide.city}
                </h3>
                <p className="text-white/70 text-xs mt-0.5">{guide.count}+ gezilecek yer</p>
              </div>
            </button>
          ))}
        </div>

        {/* All Cities A-Z Grid */}
        <div className="bg-white rounded-2xl border border-stone-100 p-6 md:p-8">
          <div className="flex items-center gap-2 mb-5">
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="ri-map-2-line text-amber-500"></i>
            </div>
            <h3 className="font-bold text-stone-900 text-base">Tüm İllerde Gezilecek Yerler</h3>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2">
            {/* Featured cities with articles — amber highlight */}
            {featuredCityLinks.map((c) => (
              <button
                key={c.name}
                onClick={() => navigate(`/article/${c.id}`)}
                className="flex items-center gap-1.5 text-xs px-3 py-2 bg-amber-50 text-amber-700 rounded-lg border border-amber-100 hover:bg-amber-100 transition-colors cursor-pointer text-left whitespace-nowrap font-medium"
              >
                <i className="ri-map-pin-line text-amber-500 text-xs flex-shrink-0"></i>
                {c.name}
              </button>
            ))}
            {/* Other cities */}
            {allCities.map((city) => (
              <button
                key={city}
                onClick={() => navigate("/articles")}
                className="flex items-center gap-1.5 text-xs px-3 py-2 bg-stone-50 text-stone-600 rounded-lg border border-stone-100 hover:bg-stone-100 transition-colors cursor-pointer text-left whitespace-nowrap"
              >
                <i className="ri-map-pin-line text-stone-400 text-xs flex-shrink-0"></i>
                {city}
              </button>
            ))}
          </div>
          <p className="text-xs text-stone-400 mt-4 text-center">
            <i className="ri-information-line mr-1"></i>
            Tüm iller için kapsamlı gezi rehberleri hazırlanmaktadır. Güncel içerikler için makaleler sayfasını takip edin.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CityGuideLinks;
